<template>
  <div class="bigbox" >
      <img-app :style="backImg" :contactTitle="contact.name" :contactList="contact.contactlist" ></img-app>
      <div class="main">
        <div class="EachDetail" >
          <div class="mainTitle ft16 lh-100 fontWeight">
            公司新闻
          </div>
          <ul class="newsList lh-200">
            <!-- <li>
              <div class="pull-left">祝贺我公司被浙江省工商行政管理局、杭州市市场监督管理局认定为“守合同重信用”单位</div>
              <div class="pull-right">2016.12.16</div>
              <div class="clear"></div>
            </li>
            <li>
              <div class="pull-left">祝贺我公司被浙江省工商行政管理局、杭州市市场监督管理局认定为“守合同重信用”单位</div>
              <div class="pull-right">2016.12.16</div>
              <div class="clear"></div>
            </li> -->
            <li v-for="item in newsList" >
              <router-link :to="item.to">
                <div class="pull-left newsList_title">{{item.title}}</div>
                <div class="pull-right">{{item.time}}</div>
                <div class="clear"></div>
              </router-link>
            </li>
          </ul>
          <pagination :total="total" :currentPage="current" @pagechange="pagechange" v-show="total>10"></pagination>
          <div class="text-center pt16 color545759 " v-show="total<=10">暂无更多</div>
        </div>
        <div class="EachDetail" >
          <div class="mainTitle ft16 lh-100 fontWeight">
            产品发布
          </div>
          <ul class="productCommon lh-200 newsList">
            
            <li v-for="item in productCommon">
              <router-link :to="item.to">
                <div class="pull-left newsList_title">{{item.title}}</div>
                <div class="pull-right">{{item.time}}</div>
                <div class="clear"></div>
              </router-link>
            </li>
          </ul>
          <div class="text-center pt16 color545759 pb96">暂无更多</div>
        </div>
        
      </div>
    </div>
</template>

<script>
 import imgApp from '@/components/common/imgApp.vue'; 
 import pagination from '@/components/common/pagination.vue'; 
 import bus from '@/assets/js/bus'
export default {
  name: 'latestNews',
  data () {
    return {
      backImg:{
        background:'url(static/images/latestNew.png) no-repeat top center'
      },
      contact:{
        name:'最新资讯',
        contactlist:[{listTitle:"公司新闻"},{listTitle:"产品发布"}]
      },
      newsList:[
        {
          title:"祝贺我公司被浙江省工商行政管理局、杭州市市场监督管理局认定为“守合同重信用”单位",
          time:"2016.12.16",
          to:'/news/1'
        },
        {
          title:"热烈祝贺我公司商标被评定为浙江省著名商标",
          time:"2016.12.16",
          to:'/news/2'
        },
        {
          title:"热烈祝贺我公司取得职业卫生技术服务机构资质证书（甲级）",
          time:"2016.12.16",
          to:'/news/3'
        },
        {
          title:"卫生部发布三项国家职业卫生标准 8月1日起实施",
          time:"2016.12.15",
          to:'/news/4'
        },
        {
          title:"我公司获评职业卫生技术服务机构甲级资质",
          time:"2016.12.15",
          to:'/news/5'
        },
        {
          title:"中国将开展煤矿作业场所粉尘危害治理专项行动",
          time:"2016.12.15",
          to:'/news/6'
        },
        {
          title:"卫生部办公厅关于征求《放射损伤防治管理条例（征求意见稿）》意见函",
          time:"2016.12.15",
          to:'/news/7'
        },
        {
          title:"卫生部发布三项国家职业卫生标准 8月1日起实施",
          time:"2016.12.15",
          to:'/news/8'
        },
        {
          title:"春节放假安排的通知",
          time:"2016.12.15",
          to:'/news/9'
        },
        {
          title:"热烈祝贺本单位取得中核集团供应商资格证书",
          time:"2016.12.15",
          to:'/news/10'
        },
      ],
      productCommon:[
        {
          title:"热烈祝贺专业家云平台V2.0和放射卫生&辐射安全管理系统V1.0上线！",
          time:"2016.12.16",
          to:'/news/product/1'
        },
        {
          title:"祝贺职业健康管理V2.0隆重上线！",
          time:"2016.12.16",
          to:'/news/product/2'
        },
        {
          title:"放射卫生&辐射安全管理系统V1.0.0.0上线！",
          time:"2016.12.16",
          to:'/news/product/3'
        },
        {
          title:"职业健康管理系统V1.0.2.0上线！",
          time:"2016.12.15",
          to:'/news/product/4'
        },
        {
          title:"职业健康管理系统V1.0.1.0上线！",
          time:"2016.12.15",
          to:'/news/product/5'
        },
        {
          title:"祝贺职业健康管理系统V1.0隆重上线！",
          time:"2016.12.15",
          to:'/news/product/6'
        },
        
      ],
      total:10,//总条数
      display:10,//每页显示的条数
      current:1,//当前页数
      li_index:0,//当前对应的li
      false:false
    }
  },
  methods:{
   pagechange(currentPage){//当点击时，当前页数传到后台，后台返回相应的页数的数据？
      console.log(currentPage)
   },
   //监听滚动距离
   changeHash(index){

      var EachDetail=$('.EachDetail');
      //获取需要滚动的距离
      let scrollHeight=EachDetail[index].offsetTop-200;
      //console.log($(document).scrollTop())

      //chrome
      /*document.body.scrollTop=scrollHeight;
      //firefox
      document.documentElement.scrollTop=scrollHeight;
      //safari
      window.pageYOffset=scrollHeight;*/
      //获取当前滚动条与顶部的距离
      let distance=document.documentElement.scrollTop||document.body.scrollTop;

      //计算每一小段的距离
      let step=scrollHeight/50;
      //屏幕向上滚动，内容由下至上
      if(distance<scrollHeight){
          smoothDown()
      }
      //屏幕向下滚动，内容由上至下
      else{
        let scrollDistance=distance-scrollHeight;
        step=scrollDistance/50;
        smoothUp();
      }
      function smoothDown(){
        if(distance<scrollHeight){
          distance+=step
          document.body.scrollTop=distance;
          document.documentElement.scrollTop=distance;
          setTimeout(smoothDown,5)
        }
        else{
          // 限制滚动停止时的距离
          document.body.scrollTop = scrollHeight
          document.documentElement.scrollTop = scrollHeight
        }
      }
      function smoothUp(){
        if (distance > scrollHeight) {
            distance -= step;
            document.body.scrollTop = distance;
            document.documentElement.scrollTop = distance;
            setTimeout(smoothUp, 10);
        } else {
            document.body.scrollTop = scrollHeight
            document.documentElement.scrollTop = scrollHeight
        }
      }
   },
   //监听页面滚动,锚点状态改变
   /*onscroll(){
      let scrolled = document.documentElement.scrollTop || document.body.scrollTop;
      let num_eachDetail=$('.EachDetail').length;
      let heightArr=[]
      for(var i=0;i<num_eachDetail;i++){
        var height = $($('.EachDetail')[i]).position().top;
        if(scrolled>68){
          height+=68
        }
        heightArr.push(height)
      }
      //console.log(scrolled,heightArr)
      if(scrolled<1038){
        this.li_index=0
      }
      else{
        this.li_index=1
      }
      
   }*/
   onScroll(){
    let scrolled = document.documentElement.scrollTop || document.body.scrollTop
    var EachDetail=$('.EachDetail');
    var arr=[];
    var mainTop=$('.main').offset().top;
    for(var i=0;i<EachDetail.length;i++){
      var topScroll=$(EachDetail[i]).position().top;
      if(mainTop!=434){
        topScroll-=68;
      }
      arr.push(topScroll);
    }
    //showAcitve(arr.length)
    
    let innerH= $($('.EachDetail')[0]).height()-200;
    if(scrolled<=arr[0]){
        bus.$emit('navChange',0);  
    }else if(arr[0]+innerH<scrolled){
      
      bus.$emit('navChange',1);
    }
   },
  },
  components:{
    "img-app":imgApp,
    "pagination":pagination
  },
  created(){
    bus.$on('navHash',(index)=>{
      this.changeHash(index);
    });
    
  },
  beforeCreate(){
    bus.$emit('NoshowAnimate',this.flase)
  },
  mounted: function () {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.onScroll)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  width: 1172px;
  margin:4px auto 0;
  padding-left: 200px;
}
.main .mainTitle{
   margin-top: 74px;
   padding-bottom: 28px;
   padding-left: 16px;
   background: url(../../static/images/current_title.png) no-repeat 2px 4px;
   color:#18191a;
}
.newsList li{
  padding-bottom: 10px;
  color:#84898c;
}
.newsList li:hover{
  color:#000;
  cursor: pointer;
} 
.newsList .newsList_title{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 648px;
}

</style>




// WEBPACK FOOTER //
// src/components/latestNews.vue